export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6681.1cd1715c.jpg";